<span class="cursor" (click)="sort()">
    <ng-content></ng-content> <fa-icon [icon]="faSort"></fa-icon>
</span>